// Тема оформления: светлая, тёмная или «как в системе». Выбор хранится в localStorage и действует для всех ролей и страниц
// (включая вход и ошибки). Класс dark-mode ставится на <html>, поэтому тёмными становятся и окна, вынесенные в <body>
// через Teleport (модальные окна, просмотр фото). Токены цветов — assets/scss/custom/_tokens.scss.
import { ref } from "vue";
import { useTemplateStore } from "@/stores/template";

export const THEME_KEY = "ilt-theme";
export const THEMES = [
  { value: "light", label: "Светлая", icon: "fa-sun" },
  { value: "dark", label: "Тёмная", icon: "fa-moon" },
  { value: "system", label: "Как в системе", icon: "fa-circle-half-stroke" },
];

const read = () => {
  try {
    const v = localStorage.getItem(THEME_KEY);

    return THEMES.some((t) => t.value === v) ? v : "system";
  } catch {
    return "system"; // хранилище недоступно (приватный режим) — следуем системе
  }
};

/** Выбранный вариант (реактивный: по нему подсвечивается переключатель). */
export const themePreference = ref(read());
/** Включена ли тёмная тема сейчас (с учётом «как в системе»). */
export const isDark = ref(false);

const systemDark = () => Boolean(window.matchMedia?.("(prefers-color-scheme: dark)").matches);

export function applyTheme(pref = themePreference.value) {
  const dark = pref === "dark" || (pref === "system" && systemDark());
  const root = document.documentElement;

  root.classList.toggle("dark-mode", dark);
  root.setAttribute("data-bs-theme", dark ? "dark" : "light");
  root.style.colorScheme = dark ? "dark" : "light";
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#202632" : "#ffffff");

  isDark.value = dark;

  // Шаблон OneUI (сайдбар, шапка, блоки) читает флаг из хранилища
  try {
    useTemplateStore().settings.darkMode = dark;
  } catch {
    // Pinia ещё не подключена (ранний вызов из main.js) — флаг подхватится при initTheme()
  }

  return dark;
}

export function setTheme(pref) {
  themePreference.value = pref;
  try {
    localStorage.setItem(THEME_KEY, pref);
  } catch {
    // без сохранения тема действует до перезагрузки
  }
  applyTheme(pref);
}

/** Подключить тему при старте: применить выбор, следить за системной темой и за изменением в соседней вкладке. */
export function initTheme() {
  themePreference.value = read();
  applyTheme();

  const mql = window.matchMedia?.("(prefers-color-scheme: dark)");
  mql?.addEventListener?.("change", () => {
    if (themePreference.value === "system") applyTheme();
  });

  window.addEventListener("storage", (e) => {
    if (e.key === THEME_KEY) {
      themePreference.value = read();
      applyTheme();
    }
  });
}
